import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { NotificationService } from 'app/core/services/notification.service';
import { AccountService } from 'app/agora/components/account-data/accounts/account.service';

@Component({
  selector: 'itpx-remove-credit-application',
  templateUrl: './remove-credit-application.component.html',
  styleUrls: ['./remove-credit-application.component.css']
})
export class RemoveCreditApplicationComponent extends RxComponent implements OnInit {

  removeForm: FormGroup;
  accountId: any;
  constructor(
    private fb: FormBuilder,
    private modalService: SmartModalService,
    private notificationService: NotificationService,
    private accountService: AccountService,
  ) {
    super();
  }
  
  ngOnInit() {
    this.accountId = this['data'];
    this.removeForm = this.fb.group({
      comment: ['', Validators.required]
    })
  }

  private onCancel() {
    this.modalService.close();
  }

  private onSubmit() {
    let details = {
      accountId: this.accountId,
      comment: this.removeForm.controls.comment.value
    }
    this.accountService.removeCreditApplication(details)
      .subscribe(
        data => {
          this.notificationService.success('The credit application has been removed',
            'Success');
          this.modalService.sendResult('success');
        },
        error => {
          this.onCancel();
        }
      )
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/details/remove-credit-application/remove-credit-application.component.ts